import $ from 'jquery';
import 'magnific-popup';

export default function popup() {
    const popups = document.querySelectorAll(".form-popup");

    // Run once when the document is ready
    $(() => {
        popups.forEach((popup) => {
            if (!popup.id) {
                console.warn('Popup missing ID', popup);
                return;
            }

            const trigger = $(`a[href="#${popup.id}"]`);
            if (trigger.length) {
                if (typeof trigger.magnificPopup === 'function') {
                    trigger.magnificPopup({
                        type: 'inline',
                        preloader: false,
                        mainClass: 'mfp-with-inline',
                        modal: true,
                        fixedContentPos: true,
                    });
                } else {
                    console.error('Magnific Popup is not loaded for', trigger);
                }
            } else {
                console.warn(`No trigger found for popup #${popup.id}`);
            }

            console.log(popup);
        });

        // Close modal on dismiss click
        $(document).on('click', '.js-popup-modal-dismiss', (e) => {
            e.preventDefault();
            if ($.magnificPopup) {
                $.magnificPopup.close();
            }
        });
    });
}
